const reasons = [
  {
    icon: 'ri-search-eye-line',
    title: 'Диагностика до обучения',
    desc: 'Сначала определяем реальные управленческие задачи, а не просто выбираем тему из каталога. Изучаем, какие сложные разговоры руководители откладывают, как обычно дают обратную связь, где возникают конфликты.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Реальные кейсы',
    desc: 'Разбираем ситуации, с которыми руководители действительно сталкиваются. Не абстрактные примеры, а конкретные сложные разговоры и ситуации с обратной связью из практики компании.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Практика',
    desc: 'Участники не только слушают, но и проводят сложные разговоры в ролевых ситуациях, получают обратную связь по своей коммуникации и отрабатывают разные подходы.',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Адаптация',
    desc: 'Содержание программы корректируется под компанию и уровень руководителей. Сложность ситуаций, примеры и акценты настраиваются под реальный управленческий контекст.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Сопровождение',
    desc: 'При необходимости после обучения разбираем реальные ситуации: как прошли сложные разговоры, что получилось внедрить, где нужна корректировка подхода.',
  },
  {
    icon: 'ri-file-copy-2-line',
    title: 'Систематизация',
    desc: 'Инструменты могут быть оформлены в алгоритмы, чек-листы и другие материалы для дальнейшего использования руководителями в ежедневной практике.',
  },
];

export default function WhyProgramsWork() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Почему наши программы работают
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Почему обучение не заканчивается тренингом, а приводит к реальным изменениям в том, как руководители дают обратную связь и проводят сложные разговоры
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reasons.map((r) => (
            <div key={r.title} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${r.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{r.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto text-center">
          <p className="text-base text-teal-800 leading-relaxed font-semibold">
            Наша задача — не научить руководителя красиво говорить об обратной связи, а помочь ему проводить разговоры, после которых меняется управленческая ситуация.
          </p>
        </div>
      </div>
    </section>
  );
}